module.exports = __webpack_public_path__ + "static/media/Group7903.bcd31d96.png";